// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"200":"coin","982":"ktoa","997":"ppomppu"}[chunkId] + "." + {"200":"e55b4f09","982":"a6b51361","997":"d6e965da"}[chunkId] + ".js";
};